class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  // Sort sizes by array defined in Shopify settings
  static sortSizes() {
    if (window.hasOwnProperty('landySizeSortBy')) {
      let sizeFilters = document.querySelectorAll('.filter-size');
      for (const sizeFilter of sizeFilters) {
        const ul_tag = sizeFilter.querySelector('ul');
        const li_tags = sizeFilter.querySelectorAll('ul li.list-menu__item');
        let items = Array.from(li_tags);
        items.sort(landySizeSortBy);
        ul_tag.replaceChildren();
        items.forEach(function (item) {
          ul_tag.appendChild(item.cloneNode(true));
        });
      }
    }
  }

  static filterHiddenVariants() {
    if (window.hasOwnProperty('hideSpecificVariants')) {
      let affectedFilters = document.querySelectorAll('.js-filter');
      for (const filter of affectedFilters) {
        const ul_tag = filter.querySelector('ul');
        const li_tags = filter.querySelectorAll('ul li.list-menu__item');
        let items = Array.from(li_tags).filter(hideSpecificVariants);

        if (ul_tag) {
          ul_tag.replaceChildren();
          items.forEach(function (item) {
            ul_tag.appendChild(item.cloneNode(true));
          });
        }
      }
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static quickAddListener() {
    if (document.querySelectorAll('.quick-add--collections').length) {
      document.querySelectorAll('.quick-add-select').forEach((select) => {
        let selectId = select.getAttribute('id');
        document.getElementById(selectId).addEventListener('change', (event) => {
          event.stopImmediatePropagation();
          quickAddItem(event.target.id);
        });
      });
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.reapplyInfiniteScroll();
        // FacetFiltersForm.renderProductCount(html);
      }).then(() => {
        FacetFiltersForm.quickAddListener();
        FacetFiltersForm.sortSizes();
        FacetFiltersForm.initializePriceSlider('desktop-slider');
        FacetFiltersForm.initializePriceSlider('mobile-slider');
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.reapplyInfiniteScroll();
    //FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.quickAddListener();
    FacetFiltersForm.initializePriceSlider('desktop-slider');
    FacetFiltersForm.initializePriceSlider('mobile-slider');
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static reapplyInfiniteScroll() {

    // hide the aggressive loader if present
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if(container)
      container.classList.remove('loading');

    if(containerDesktop)
      containerDesktop.classList.remove('loading');

    // update the count
    const items = document.getElementsByClassName('grid__item-plp');
    const count = items.length;
    const pageCountElement = document.getElementById('pageCount');
    if (pageCountElement) {
        pageCountElement.textContent = count;
    }
    
    // alert the infinite scroll
    window.currentPage = 1;
    document.dispatchEvent(
      new CustomEvent("FacetLoaded", {
        bubbles: true,
        detail: {},
      }),
    );
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  static initializePriceSlider(sliderId) {
    var slider = document.getElementById(sliderId);

    if (!slider || (slider && slider.noUiSlider)) {
      return; // Stop function if the slider is already initialized OR slider ID is not found
    }

    var minPrice = parseFloat(slider.getAttribute('data-min-price'));
    var maxPrice = parseFloat(slider.getAttribute('data-max-price'));

    noUiSlider.create(slider, {
      start: [minPrice, maxPrice],
      connect: true,
      step: 5,
      margin: 5,
      range: {
        'min': minPrice,
        'max': maxPrice
      }
    });

    slider.noUiSlider.on('slide', function (values, handle) {
      FacetFiltersForm.updateInputFields(values, sliderId);
    });
  }

  static updateInputFields(values, sliderId) {
    var fromInputId = sliderId === 'desktop-slider' ? 'Filter-Price-GTE' : 'Mobile-Filter-Price-GTE';
    var toInputId = sliderId === 'desktop-slider' ? 'Filter-Price-LTE' : 'Mobile-Filter-Price-LTE';

    var fromInput = document.getElementById(fromInputId);
    var toInput = document.getElementById(toInputId);

    if (fromInput && toInput) {
      fromInput.value = parseFloat(values[0]).toFixed(2);
      toInput.value = parseFloat(values[1]).toFixed(2);

      ['input', 'change'].forEach(eventType => {
        var event = new Event(eventType, { bubbles: true, cancelable: true });
        fromInput.dispatchEvent(event);
        toInput.dispatchEvent(event);
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.sortSizes();
FacetFiltersForm.filterHiddenVariants();
FacetFiltersForm.setListeners();
FacetFiltersForm.initializePriceSlider('desktop-slider');
FacetFiltersForm.initializePriceSlider('mobile-slider');

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);
